import { render, staticRenderFns } from "./dialog-tagversionoptional.vue?vue&type=template&id=b58337c2&"
import script from "./dialog-tagversionoptional.vue?vue&type=script&lang=js&"
export * from "./dialog-tagversionoptional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports